<template>
  <v-autocomplete
    v-model="localValue"
    :items="facilities"
    :item-value="resolvedItemValue"
    :item-text="itemText"
    :label="label"
    :multiple="multiple"
    :chips="chips"
    :dense="dense"
    :outlined="outlined"
    :clearable="clearable"
    :rules="rules"
    :hint="localValue"
    :persistent-hint="true"
  />
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "FacilitySelect",
  props: {
    value: {
      type: [String, Number, Array],
      default: () => [],
    },
    itemValue: {
      type: [String, Function],
      default: "node.facilityId",
    },
    itemText: {
      type: String,
      default: "node.name",
    },
    label: {
      type: String,
      default: "Select Facility",
    },
    multiple: {
      type: Boolean,
      default: true,
    },
    chips: {
      type: Boolean,
      default: true,
    },
    dense: {
      type: Boolean,
      default: true,
    },
    outlined: {
      type: Boolean,
      default: true,
    },
    clearable: {
      type: Boolean,
      default: true,
    },
    rules: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    ...mapGetters(["getFacilities"]),

    facilities() {
      return this.getFacilities;
    },

    resolvedItemValue() {
      if (typeof this.itemValue === "function") {
        return this.itemValue;
      }

      const path = this.itemValue.split(".");
      return (item) => {
        return path.reduce(
          (obj, key) => (obj && obj[key] !== undefined ? obj[key] : null),
          item
        );
      };
    },

    localValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
  created() {
    if (!this.facilities || this.facilities.length === 0) {
      this.$store.dispatch("allFacility");
    }
  },
};
</script>
